import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as glExpenseIdcFunctionalization from '../../gl-expense-idc-functionalization'

export const RESOURCE = {
  payload: {
    description:
      'The association(s) between general ledger expenses and indirect cost categories.',
    dimension: glExpenseIdcFunctionalization.RESOURCE.payload,
    level: 0,
    name: 'GL IDC Mapping',
    partialId: PartialId.Standard.create('entry'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
